<template>
  <div class="category-bar">

    <!-- SKELETON -->
    <div v-if="loading" class="scroll">
      <div 
        v-for="i in 8" 
        :key="i" 
        class="skeleton-chip"
      ></div>
    </div>

    <!-- CATEGORÍAS -->
    <div 
      v-else 
      class="scroll"
      ref="scrollRef"
    >
      <div
        v-for="cat in categories"
        :key="cat.id"
        class="chip"
        :class="{ active: selected === cat.slug }"
        @click="selectCategory(cat)"
      >
        {{ cat.name }}
      </div>
    </div>

  </div>
</template>

<script setup>
import { ref, onMounted, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import api from '../services/api'

const router = useRouter()
const route = useRoute()

const categories = ref([])
const loading = ref(true)
const selected = ref('')

// cargar categorías
const loadCategories = async () => {
  try {
    const { data } = await api.get('/allcategories')
    categories.value = data.categories
  } catch (error) {
    console.error(error)
  } finally {
    loading.value = false
  }
}

onMounted(loadCategories)

// click
const selectCategory = (cat) => {
  selected.value = cat.slug

  router.push({
    name: 'categoria',
    params: { slug: cat.slug }
  })
}

// sincronizar con URL
watch(
  () => route.params.slug,
  (newSlug) => {
    selected.value = newSlug
  },
  { immediate: true }
)
</script>

<style scoped>
.category-bar {
  background: #fff;
  padding: 8px 0;
  position: fixed;
  top: 38px; /* 🔥 Cambiado: usar top en lugar de margin-top */
  left: 0;
  right: 0;
  z-index: 999;
}

/* SCROLL HORIZONTAL PRO */
.scroll {
  display: flex;
  gap: 8px;
  padding: 0 15px;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  scroll-behavior: smooth;
  width: 100%; /* 🔥 Asegurar ancho completo */
}

/* ocultar scrollbar pero permitir scroll */
.scroll::-webkit-scrollbar {
  display: none;
}

/* CHIP */
.chip {
  flex: 0 0 auto;
  padding: 6px 16px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 500;
  white-space: nowrap;
  cursor: pointer;
  transition: all 0.2s ease;
  color: #374151;
}

/* ACTIVO */
.chip.active {
  background: #00144a;
  color: #fff;
}

/* HOVER */
.chip:hover {
  background: #dbeafe;
}

/* SKELETON */
.skeleton-chip {
  flex: 0 0 auto;
  min-width: 80px;
  height: 34px;
  border-radius: 20px;
  background: #e5e7eb;
  position: relative;
  overflow: hidden;
}

.skeleton-chip::after {
  content: '';
  position: absolute;
  width: 150%;
  height: 100%;
  left: -150%;
  top: 0;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255,255,255,0.6),
    transparent
  );
  animation: shimmer 1.2s infinite;
}

@keyframes shimmer {
  100% {
    left: 150%;
  }
}
</style>